import type { NormalizedCacheObject } from "@apollo/client";
import type { ApolloCache } from "@apollo/client/cache/core/cache";
import { isNil } from "ramda";

type InvalidateFunction = <TData = unknown>(cache: ApolloCache<NormalizedCacheObject>, data: TData) => void;

export const composeUpdates = (functions: InvalidateFunction[]): InvalidateFunction => {
  return (cache, data) =>
    functions.forEach((func) => {
      func(cache, data);
    });
};

export const invalidateUsersList: InvalidateFunction = (cache) => {
  cache.evict({ id: "ROOT_QUERY", fieldName: "users" });
};

export const invalidatePatientsList: InvalidateFunction = (cache) => {
  cache.evict({ id: "ROOT_QUERY", fieldName: "patients" });
};

export const invalidatePatientDetails: InvalidateFunction = (cache) => {
  const cacheContent = cache.extract();
  if (!isNil(cacheContent.ROOT_QUERY)) {
    Object.keys(cacheContent.ROOT_QUERY)
      .filter((key) => key.match(/patient\(.*\)/))
      .map((key) => ({ id: "ROOT_QUERY", fieldName: key }))
      .forEach((eviction) => cache.evict(eviction));
  }
};

export const collectGarbage: InvalidateFunction = (cache) => {
  cache.gc();
};
